import React, { useEffect, useState } from 'react'
import { GetASD, GroupByPropCheck } from '../../Finanzas/Actions/GetContainer';
import { TextField } from '@mui/material';

export const BuscadorModelosPromocion = ({ data, datafiltro, setDatafiltro, filtrar, setFiltrar, keyFiltrado }) => {
    const [predictivo, setPredictivo] = useState("");
    const [state, setState] = useState([])
    // const [arrayClientes, setArrayClientes] = useState([]);
    const [selectedFilters, setSelectedFilters] = useState({
        modelo: []
    });

    useEffect(() => {
        // const dataToFilter = selectedFilters.estatus.length > 0 ? state : data;
        const result = data.filter((item) => {
            return (
                // item.mdl_descripcion?.toUpperCase().includes(predictivo.toUpperCase()) ||
                item.modelo?.toUpperCase().includes(predictivo.toUpperCase())
            );
        });

        setDatafiltro(result);
    }, [predictivo, state, data, selectedFilters]);  // Asegúrate de que todas las dependencias estén aquí



    return (
        <div className='esquemas-modelo-buscador-container'>
            <div className="esquemas-modelos-header-control">
                <TextField
                    color="success"
                    fullWidth
                    sx={{
                        ml: 1,
                        // Asegura que el contenedor del OutlinedInput mida 48px
                        "& .MuiOutlinedInput-root": {
                            height: 40,
                        },
                        // Ajusta el padding vertical para centrar el texto
                        "& .MuiOutlinedInput-input": {
                            padding: "12px 14px",
                        },
                    }}
                    size="small"
                    value={predictivo}
                    onChange={({ target }) => setPredictivo(target.value)}
                    placeholder="Buscar por Modelo"
                />
            </div>
        </div>
    )
}
